import { store } from '@/store';

export default function groupIsValid(groupName) {
  const groupRoles = store.state.authentication.user.roles.find((role) => role.name === groupName);
  const foundGroup = store.state.authentication.user.groups
    .find((group) => group.name === groupName && !groupRoles.roles.find((role) => role === 'restrictive-dashboard'));

  return !!foundGroup;
}
